export {
  StudyTimeAreaChart,
  StudyTimeAreaChartProps,
} from './StudyTimeAreaChart';
